import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideo from '@/components/UI/EFVideo';

export default function Comp() {
    const { useLang } = useGlobal();
    const { t } = useLang('smarthomepanel');

    return (
        <div className={`${css.gsapA1} gsapA1`}>
            <div className="video-wrapper">
                <EFVideo sources={['/video/smarthomepanel/kv.webm', '/video/smarthomepanel/kv.mp4']} className="video" width={'1120px'} loop={false} />
            </div>
            <div className="watch-field">
                <div className="first gsapA1-trigger-a1">
                    <h3 className="font-family-bold title">{t('smart_home_panel.title')}</h3>
                    <p className="font-family-semibolder desc">{t('smart_home_panel.subtitle')}</p>
                </div>
                <div className="second font-family-semibold gsapA1-trigger-a2">{t('smart_home_panel.third_title')}</div>
            </div>
        </div>
    );
}
